/**
 * Avedian Landing - Theme JS
 * Shopify-compatible vanilla JS (no dependencies)
 */

(function () {
  'use strict';

  /* ==========================================================================
     COUNTRIES DATA
     ========================================================================== */
  var countries = [
    { name: 'España', code: '+34', flag: '\u{1F1EA}\u{1F1F8}' },
    { name: 'México', code: '+52', flag: '\u{1F1F2}\u{1F1FD}' },
    { name: 'Colombia', code: '+57', flag: '\u{1F1E8}\u{1F1F4}' },
    { name: 'Argentina', code: '+54', flag: '\u{1F1E6}\u{1F1F7}' },
    { name: 'Chile', code: '+56', flag: '\u{1F1E8}\u{1F1F1}' },
    { name: 'Perú', code: '+51', flag: '\u{1F1F5}\u{1F1EA}' },
    { name: 'Ecuador', code: '+593', flag: '\u{1F1EA}\u{1F1E8}' },
    { name: 'Venezuela', code: '+58', flag: '\u{1F1FB}\u{1F1EA}' },
    { name: 'Estados Unidos', code: '+1', flag: '\u{1F1FA}\u{1F1F8}' },
    { name: 'Reino Unido', code: '+44', flag: '\u{1F1EC}\u{1F1E7}' },
    { name: 'Francia', code: '+33', flag: '\u{1F1EB}\u{1F1F7}' },
    { name: 'Alemania', code: '+49', flag: '\u{1F1E9}\u{1F1EA}' },
    { name: 'Italia', code: '+39', flag: '\u{1F1EE}\u{1F1F9}' },
    { name: 'Portugal', code: '+351', flag: '\u{1F1F5}\u{1F1F9}' },
    { name: 'Brasil', code: '+55', flag: '\u{1F1E7}\u{1F1F7}' },
    { name: 'República Dominicana', code: '+1-809', flag: '\u{1F1E9}\u{1F1F4}' },
    { name: 'Costa Rica', code: '+506', flag: '\u{1F1E8}\u{1F1F7}' },
    { name: 'Panamá', code: '+507', flag: '\u{1F1F5}\u{1F1E6}' },
    { name: 'Uruguay', code: '+598', flag: '\u{1F1FA}\u{1F1FE}' },
    { name: 'Paraguay', code: '+595', flag: '\u{1F1F5}\u{1F1FE}' },
    { name: 'Bolivia', code: '+591', flag: '\u{1F1E7}\u{1F1F4}' },
    { name: 'Guatemala', code: '+502', flag: '\u{1F1EC}\u{1F1F9}' },
    { name: 'Honduras', code: '+504', flag: '\u{1F1ED}\u{1F1F3}' },
    { name: 'El Salvador', code: '+503', flag: '\u{1F1F8}\u{1F1FB}' },
    { name: 'Nicaragua', code: '+505', flag: '\u{1F1F3}\u{1F1EE}' },
    { name: 'Cuba', code: '+53', flag: '\u{1F1E8}\u{1F1FA}' }
  ];

  /* ==========================================================================
     MOBILE MENU
     ========================================================================== */
  var menuToggle = document.querySelector('.header__menu-toggle');
  var header = document.querySelector('.header');

  if (menuToggle && header) {
    menuToggle.addEventListener('click', function () {
      var isOpen = header.classList.toggle('is-open');
      this.setAttribute('aria-expanded', isOpen);
    });
  }

  /* ==========================================================================
     SMOOTH SCROLL
     ========================================================================== */
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var href = this.getAttribute('href');
      if (href === '#') return;
      var target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        var offset = 80; // header height + gap
        var top = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });

        // Close mobile menu if open
        if (header && header.classList.contains('is-open')) {
          header.classList.remove('is-open');
          if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
        }
      }
    });
  });

  /* ==========================================================================
     HERO STAT COUNTER ANIMATION
     ========================================================================== */
  function animateCounters() {
    var counters = document.querySelectorAll('.hero__stat-number[data-count]');
    counters.forEach(function (el) {
      var target = parseInt(el.getAttribute('data-count'), 10);
      var prefix = el.textContent.charAt(0) === '+' ? '+' : '';
      var duration = 1800;
      var startTime = null;

      function step(timestamp) {
        if (!startTime) startTime = timestamp;
        var progress = Math.min((timestamp - startTime) / duration, 1);
        // Ease out cubic
        var eased = 1 - Math.pow(1 - progress, 3);
        var current = Math.floor(eased * target);
        el.textContent = prefix + current;
        if (progress < 1) {
          requestAnimationFrame(step);
        } else {
          el.textContent = prefix + target;
        }
      }

      requestAnimationFrame(step);
    });
  }

  // Trigger counters when hero is visible
  var heroSection = document.querySelector('.hero');
  if (heroSection) {
    var heroObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          setTimeout(animateCounters, 700); // Wait for entrance animations
          heroObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });
    heroObserver.observe(heroSection);
  }

  /* ==========================================================================
     SCROLL ANIMATIONS
     ========================================================================== */
  var animatedElements = document.querySelectorAll(
    '.feature-card, .testimonial-card, .hero__content, .cta__content, .quiz-card, .contact-wrapper, .faq__item'
  );

  if ('IntersectionObserver' in window && animatedElements.length) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    animatedElements.forEach(function (el) {
      el.classList.add('animate-on-scroll');
      observer.observe(el);
    });
  }

  /* ==========================================================================
     HEADER SCROLL SHADOW
     ========================================================================== */
  window.addEventListener('scroll', function () {
    if (header) {
      if (window.scrollY > 10) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    }
  }, { passive: true });

  /* ==========================================================================
     PROGRAMS CAROUSEL
     ========================================================================== */
  var carousel = document.getElementById('programs-carousel');

  if (carousel) {
    var track = carousel.querySelector('.carousel__track');
    var slides = carousel.querySelectorAll('.carousel__slide');
    var prevBtn = carousel.querySelector('.carousel__btn--prev');
    var nextBtn = carousel.querySelector('.carousel__btn--next');
    var dotsContainer = document.getElementById('carousel-dots');
    var currentIndex = 0;
    var autoplayInterval = null;
    var autoplayDelay = 5000; // 5 seconds

    function getSlidesPerView() {
      // How many slides currently fit in the track viewport
      var slideW = slides[0] ? slides[0].offsetWidth : 0;
      var trackW = track.clientWidth;
      if (!slideW || !trackW) return 1;
      return Math.max(1, Math.floor(trackW / slideW));
    }

    function getMaxIndex() {
      return Math.max(0, slides.length - getSlidesPerView());
    }

    function updateNavVisibility() {
      var navNeeded = getMaxIndex() > 0;
      if (prevBtn) prevBtn.style.display = navNeeded ? '' : 'none';
      if (nextBtn) nextBtn.style.display = navNeeded ? '' : 'none';
      if (dotsContainer) dotsContainer.style.display = navNeeded ? '' : 'none';
    }

    function updateCarousel() {
      var target = slides[currentIndex];
      if (target) {
        var trackRect = track.getBoundingClientRect();
        var slideRect = target.getBoundingClientRect();
        var maxScroll = track.scrollWidth - track.clientWidth;
        var desired = track.scrollLeft + (slideRect.left - trackRect.left);
        desired = Math.max(0, Math.min(desired, maxScroll));
        track.scrollTo({ left: desired, behavior: 'smooth' });
      }
      updateDots();
      updateNavVisibility();
    }

    function createDots() {
      if (!dotsContainer) return;
      dotsContainer.innerHTML = '';
      var totalDots = getMaxIndex() + 1;
      for (var i = 0; i < totalDots; i++) {
        var dot = document.createElement('button');
        dot.className = 'carousel__dot' + (i === currentIndex ? ' carousel__dot--active' : '');
        dot.setAttribute('aria-label', 'Ir al programa ' + (i + 1));
        dot.setAttribute('data-index', i);
        dotsContainer.appendChild(dot);
      }
    }

    function updateDots() {
      if (!dotsContainer) return;
      var dots = dotsContainer.querySelectorAll('.carousel__dot');
      // Recreate if count changed (resize)
      if (dots.length !== getMaxIndex() + 1) {
        createDots();
        return;
      }
      dots.forEach(function (dot, i) {
        dot.classList.toggle('carousel__dot--active', i === currentIndex);
      });
    }

    function goTo(index) {
      var max = getMaxIndex();
      currentIndex = Math.max(0, Math.min(index, max));
      updateCarousel();
    }

    function goNext() {
      if (currentIndex >= getMaxIndex()) {
        goTo(0); // Loop back
      } else {
        goTo(currentIndex + 1);
      }
    }

    function goPrev() {
      if (currentIndex <= 0) {
        goTo(getMaxIndex()); // Loop to end
      } else {
        goTo(currentIndex - 1);
      }
    }

    function startAutoplay() {
      stopAutoplay();
      if (getMaxIndex() === 0) return; // nothing to rotate through
      autoplayInterval = setInterval(goNext, autoplayDelay);
    }

    function stopAutoplay() {
      if (autoplayInterval) {
        clearInterval(autoplayInterval);
        autoplayInterval = null;
      }
    }

    // Navigation buttons
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goPrev();
        stopAutoplay();
        startAutoplay(); // Reset timer
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goNext();
        stopAutoplay();
        startAutoplay();
      });
    }

    // Dots click
    if (dotsContainer) {
      dotsContainer.addEventListener('click', function (e) {
        var dot = e.target.closest('.carousel__dot');
        if (dot) {
          var idx = parseInt(dot.getAttribute('data-index'), 10);
          goTo(idx);
          stopAutoplay();
          startAutoplay();
        }
      });
    }

    // Pause on hover
    carousel.addEventListener('mouseenter', stopAutoplay);
    carousel.addEventListener('mouseleave', startAutoplay);

    // Sync dots with native scroll position (works on both desktop & mobile)
    var scrollSyncTimer;
    track.addEventListener('scroll', function () {
      stopAutoplay();
      clearTimeout(scrollSyncTimer);
      scrollSyncTimer = setTimeout(function () {
        var slideW = slides[0] ? slides[0].offsetWidth : 0;
        var gap = parseFloat(getComputedStyle(track).columnGap || '0') || 0;
        var step = slideW + gap;
        if (!step) return;
        var idx = Math.round(track.scrollLeft / step);
        idx = Math.max(0, Math.min(idx, getMaxIndex()));
        if (idx !== currentIndex) {
          currentIndex = idx;
          updateDots();
        }
        startAutoplay();
      }, 140);
    }, { passive: true });

    // Handle resize
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (currentIndex > getMaxIndex()) {
          currentIndex = getMaxIndex();
        }
        updateCarousel();
      }, 150);
    });

    // Initialize
    createDots();
    updateCarousel();
    startAutoplay();
  }

  /* ==========================================================================
     COUNTRY PHONE SELECTOR
     ========================================================================== */
  var countryBtn = document.getElementById('country-selector-btn');
  var countryDropdown = document.getElementById('country-dropdown');
  var selectedFlag = document.getElementById('selected-flag');
  var selectedCode = document.getElementById('selected-code');
  var selectedCountryCode = '+34'; // default España

  if (countryBtn && countryDropdown) {
    // Populate dropdown
    countries.forEach(function (country) {
      var option = document.createElement('button');
      option.type = 'button';
      option.className = 'phone-country-option';
      option.setAttribute('role', 'option');
      option.setAttribute('data-code', country.code);
      option.setAttribute('data-flag', country.flag);
      option.innerHTML =
        '<span class="phone-country-option__flag">' + country.flag + '</span>' +
        '<span class="phone-country-option__name">' + country.name + '</span>' +
        '<span class="phone-country-option__code">' + country.code + '</span>';
      countryDropdown.appendChild(option);
    });

    // Toggle dropdown
    countryBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = countryDropdown.classList.toggle('is-open');
      countryBtn.setAttribute('aria-expanded', isOpen);
    });

    // Select country
    countryDropdown.addEventListener('click', function (e) {
      var option = e.target.closest('.phone-country-option');
      if (option) {
        selectedCountryCode = option.getAttribute('data-code');
        selectedFlag.textContent = option.getAttribute('data-flag');
        selectedCode.textContent = selectedCountryCode;
        countryDropdown.classList.remove('is-open');
        countryBtn.setAttribute('aria-expanded', 'false');

        // Focus phone input
        var phoneInput = document.getElementById('contact-phone');
        if (phoneInput) phoneInput.focus();
      }
    });

    // Close dropdown on outside click
    document.addEventListener('click', function (e) {
      if (!countryBtn.contains(e.target) && !countryDropdown.contains(e.target)) {
        countryDropdown.classList.remove('is-open');
        countryBtn.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ==========================================================================
     FORM VALIDATION HELPERS
     ========================================================================== */
  function validateEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function validatePhone(phone) {
    var digits = phone.replace(/\D/g, '');
    return digits.length >= 7;
  }

  function showError(inputEl, errorEl, message) {
    if (inputEl) inputEl.classList.add('is-error');
    if (errorEl) errorEl.textContent = message;
  }

  function clearError(inputEl, errorEl) {
    if (inputEl) inputEl.classList.remove('is-error');
    if (errorEl) errorEl.textContent = '';
  }

  function clearAllErrors(form) {
    form.querySelectorAll('.is-error').forEach(function (el) {
      el.classList.remove('is-error');
    });
    form.querySelectorAll('.form-error').forEach(function (el) {
      el.textContent = '';
    });
  }

  /* ==========================================================================
     QUIZ LEAD FORM
     ========================================================================== */
  var quizForm = document.getElementById('quiz-lead-form');

  if (quizForm) {
    quizForm.addEventListener('submit', function (e) {
      e.preventDefault();
      clearAllErrors(quizForm);

      var nameInput = document.getElementById('quiz-name');
      var emailInput = document.getElementById('quiz-email');
      var termsInput = document.getElementById('quiz-terms');
      var nameError = document.getElementById('quiz-name-error');
      var emailError = document.getElementById('quiz-email-error');
      var termsError = document.getElementById('quiz-terms-error');
      var isValid = true;

      // Validate name
      if (!nameInput.value.trim()) {
        showError(nameInput, nameError, 'Por favor, ingresa tu nombre');
        isValid = false;
      }

      // Validate email
      if (!emailInput.value.trim()) {
        showError(emailInput, emailError, 'Por favor, ingresa tu correo');
        isValid = false;
      } else if (!validateEmail(emailInput.value.trim())) {
        showError(emailInput, emailError, 'Ingresa un correo válido');
        isValid = false;
      }

      // Validate terms
      if (termsInput && !termsInput.checked) {
        showError(termsInput, termsError, 'Debes aceptar los Términos y Condiciones');
        isValid = false;
      }

      if (!isValid) return;

      // Send to Web3Forms
      var submitBtn = quizForm.querySelector('.quiz-form__submit');
      var originalText = submitBtn.innerHTML;
      submitBtn.disabled = true;
      submitBtn.innerHTML = '<svg class="spinner" width="20" height="20" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" stroke-dasharray="30 70" stroke-linecap="round"/></svg> Enviando...';

      function advanceToQuiz() {
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalText;
        var step1 = document.getElementById('quiz-step-1');
        var step2 = document.getElementById('quiz-step-2');
        if (step1 && step2) {
          step1.classList.remove('quiz-step--active');
          step2.classList.add('quiz-step--active');
          step2.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }

      var formData = new FormData(quizForm);

      fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        body: formData
      })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (!data.success) {
          console.warn('Web3Forms quiz:', data.message);
        }
        advanceToQuiz();
      })
      .catch(function (err) {
        console.warn('Web3Forms quiz error:', err);
        advanceToQuiz();
      });
    });
  }

  /* ==========================================================================
     CONTACT FORM
     ========================================================================== */
  var contactForm = document.getElementById('contact-form');

  if (contactForm) {
    contactForm.addEventListener('submit', function (e) {
      e.preventDefault();
      clearAllErrors(contactForm);

      var nameInput = document.getElementById('contact-name');
      var phoneInput = document.getElementById('contact-phone');
      var messageInput = document.getElementById('contact-message');
      var termsInput = document.getElementById('contact-terms');

      var nameError = document.getElementById('contact-name-error');
      var phoneError = document.getElementById('contact-phone-error');
      var messageError = document.getElementById('contact-message-error');
      var termsError = document.getElementById('contact-terms-error');

      var isValid = true;

      // Validate name
      if (!nameInput.value.trim()) {
        showError(nameInput, nameError, 'Por favor, ingresa tu nombre');
        isValid = false;
      }

      // Validate phone
      if (!phoneInput.value.trim()) {
        showError(phoneInput, phoneError, 'Por favor, ingresa tu teléfono');
        isValid = false;
      } else if (!validatePhone(phoneInput.value.trim())) {
        showError(phoneInput, phoneError, 'Ingresa un teléfono válido (mínimo 7 dígitos)');
        isValid = false;
      }

      // Validate message
      if (!messageInput.value.trim()) {
        showError(messageInput, messageError, 'Por favor, escribe un mensaje');
        isValid = false;
      }

      // Validate terms
      if (!termsInput.checked) {
        showError(null, termsError, 'Debes aceptar los Términos y Condiciones');
        isValid = false;
      }

      if (!isValid) return;

      // Show loading state
      var submitBtn = document.getElementById('contact-submit-btn');
      var btnText = submitBtn.querySelector('.btn__text');
      var btnLoading = submitBtn.querySelector('.btn__loading');
      submitBtn.disabled = true;
      btnText.style.display = 'none';
      btnLoading.style.display = 'inline-flex';

      var fullPhone = selectedCountryCode + ' ' + phoneInput.value.trim();

      // Build FormData for Web3Forms
      var formData = new FormData(contactForm);
      formData.set('phone', fullPhone);

      fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        body: formData
      })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        submitBtn.disabled = false;
        btnText.style.display = '';
        btnLoading.style.display = 'none';

        if (data.success) {
          contactForm.style.display = 'none';
          var successEl = document.getElementById('contact-success');
          if (successEl) successEl.style.display = 'block';
        } else {
          console.warn('Web3Forms:', data.message);
          alert('Hubo un error al enviar. Inténtalo de nuevo.');
        }
      })
      .catch(function (err) {
        submitBtn.disabled = false;
        btnText.style.display = '';
        btnLoading.style.display = 'none';
        console.warn('Web3Forms error:', err);
        alert('Error de conexión. Inténtalo de nuevo.');
      });
    });

    // Clear field errors on input
    contactForm.querySelectorAll('.form-input').forEach(function (input) {
      input.addEventListener('input', function () {
        var errorEl = document.getElementById(this.id + '-error');
        clearError(this, errorEl);
      });
    });
  }

  /* ==========================================================================
     TEAM CAROUSEL (mobile only)
     ========================================================================== */
  var teamCarousel = document.getElementById('team-carousel');

  if (teamCarousel) {
    var teamTrack = teamCarousel.querySelector('.team__track');
    var teamSlides = teamCarousel.querySelectorAll('.team__slide');
    var teamDotsContainer = document.getElementById('team-dots');
    var teamIndex = 0;
    var teamAutoplay = null;
    var teamIsMobile = false;

    function checkTeamMobile() {
      return window.innerWidth <= 768;
    }

    function updateTeamCarousel() {
      if (!teamIsMobile) {
        teamTrack.style.transform = '';
        return;
      }
      var offset = teamIndex * 100;
      teamTrack.style.transform = 'translateX(-' + offset + '%)';
      updateTeamDots();
    }

    function createTeamDots() {
      if (!teamDotsContainer) return;
      teamDotsContainer.innerHTML = '';
      for (var i = 0; i < teamSlides.length; i++) {
        var dot = document.createElement('button');
        dot.className = 'team__dot' + (i === teamIndex ? ' team__dot--active' : '');
        dot.setAttribute('aria-label', 'Ver especialista ' + (i + 1));
        dot.setAttribute('data-index', i);
        teamDotsContainer.appendChild(dot);
      }
    }

    function updateTeamDots() {
      if (!teamDotsContainer) return;
      var dots = teamDotsContainer.querySelectorAll('.team__dot');
      dots.forEach(function (dot, i) {
        dot.classList.toggle('team__dot--active', i === teamIndex);
      });
    }

    function teamNext() {
      teamIndex = (teamIndex + 1) % teamSlides.length;
      updateTeamCarousel();
    }

    function startTeamAutoplay() {
      stopTeamAutoplay();
      if (teamIsMobile) {
        teamAutoplay = setInterval(teamNext, 3000);
      }
    }

    function stopTeamAutoplay() {
      if (teamAutoplay) {
        clearInterval(teamAutoplay);
        teamAutoplay = null;
      }
    }

    function initTeamCarousel() {
      var wasMobile = teamIsMobile;
      teamIsMobile = checkTeamMobile();

      if (teamIsMobile && !wasMobile) {
        teamIndex = 0;
        createTeamDots();
        updateTeamCarousel();
        startTeamAutoplay();
      } else if (!teamIsMobile && wasMobile) {
        stopTeamAutoplay();
        teamTrack.style.transform = '';
        if (teamDotsContainer) teamDotsContainer.innerHTML = '';
      }
    }

    // Dots click
    if (teamDotsContainer) {
      teamDotsContainer.addEventListener('click', function (e) {
        var dot = e.target.closest('.team__dot');
        if (dot) {
          teamIndex = parseInt(dot.getAttribute('data-index'), 10);
          updateTeamCarousel();
          stopTeamAutoplay();
          startTeamAutoplay();
        }
      });
    }

    // Touch/swipe
    var teamTouchStart = 0;
    teamCarousel.addEventListener('touchstart', function (e) {
      teamTouchStart = e.changedTouches[0].screenX;
      stopTeamAutoplay();
    }, { passive: true });

    teamCarousel.addEventListener('touchend', function (e) {
      var diff = teamTouchStart - e.changedTouches[0].screenX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) {
          teamIndex = (teamIndex + 1) % teamSlides.length;
        } else {
          teamIndex = (teamIndex - 1 + teamSlides.length) % teamSlides.length;
        }
        updateTeamCarousel();
      }
      startTeamAutoplay();
    }, { passive: true });

    // Resize handler
    var teamResizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(teamResizeTimer);
      teamResizeTimer = setTimeout(initTeamCarousel, 150);
    });

    // Init
    initTeamCarousel();
  }

  /* ==========================================================================
     FAQ ACCORDION
     ========================================================================== */
  var faqItems = document.querySelectorAll('.faq__item');
  faqItems.forEach(function (item) {
    var btn = item.querySelector('.faq__question');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var isOpen = item.classList.contains('is-open');
      // Close all others
      faqItems.forEach(function (other) {
        other.classList.remove('is-open');
        var otherBtn = other.querySelector('.faq__question');
        if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
      });
      // Toggle current
      if (!isOpen) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ==========================================================================
     PARALLAX (subtle)
     ========================================================================== */
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!prefersReduced) {
    var heroBg = document.querySelector('.hero__bg');
    var quizBg = document.querySelector('.quiz-section__bg');
    var parallaxSections = document.querySelectorAll(
      '.features, .programs-section, .team-section, .contact-section, .cta, .faq-section'
    );

    var ticking = false;

    function onParallaxScroll() {
      if (ticking) return;
      ticking = true;

      requestAnimationFrame(function () {
        var scrollY = window.pageYOffset;
        var winH = window.innerHeight;

        // Hero background — moves slower than scroll (classic parallax)
        if (heroBg) {
          heroBg.style.transform = 'translateY(' + (scrollY * 0.35) + 'px)';
        }

        // Quiz section background parallax — more pronounced movement
        if (quizBg) {
          var quizRect = quizBg.closest('.quiz-section').getBoundingClientRect();
          var quizOffset = quizRect.top / winH;
          quizBg.style.transform = 'translateY(' + (quizOffset * -60) + 'px)';
        }

        // Section orbs — shift gently based on scroll position
        parallaxSections.forEach(function (section) {
          var rect = section.getBoundingClientRect();
          var sectionCenter = rect.top + rect.height / 2;
          var offset = (sectionCenter - winH / 2) / winH;
          var shift = offset * -30;
          section.style.setProperty('--parallax-y', shift + 'px');
        });

        ticking = false;
      });
    }

    window.addEventListener('scroll', onParallaxScroll, { passive: true });
    onParallaxScroll(); // init
  }

  /* ==========================================================================
     BACK TO TOP
     ========================================================================== */
  var backToTop = document.querySelector('.footer__back-to-top');
  if (backToTop) {
    backToTop.addEventListener('click', function (e) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

})();
